const AMOUNT = /\$?\s*(\d[\d,]*(?:\.\d+)?)\s*(k|m|mil|million|thousand)?\b/gi;
const MULT = { k: 1e3, thousand: 1e3, m: 1e6, mil: 1e6, million: 1e6 };

// Sums every dollar amount found in a free-text answer; null if none.
export const parseAmounts = (text) => {
  if (!text) return null;
  let total = 0;
  let found = false;
  for (const [, num, unit] of text.matchAll(AMOUNT)) {
    const n = parseFloat(num.replace(/,/g, ""));
    if (!Number.isFinite(n)) continue;
    total += n * (MULT[(unit || "").toLowerCase()] || 1);
    found = true;
  }
  return found ? total : null;
};

const isPension = (text) => /\b(p\.?\s?a\.?|per\s+(annum|year)|pension|annual|yearly)\b/i.test(text || "");

export const netWorth = (e) => {
  const parts = [
    ["Super", parseAmounts(e.household_super), 1],
    ["DB fund", isPension(e.db_fund_value) ? null : parseAmounts(e.db_fund_value), 1],
    ["Other assets", parseAmounts(e.other_assets), 1],
    ["Debt", parseAmounts(e.debt_level), -1],
  ].filter(([, v]) => v !== null);
  if (!parts.length) return null;
  return { total: parts.reduce((s, [, v, sign]) => s + v * sign, 0), parts };
};

export const fmtMoney = (n) =>
  `${n < 0 ? "-" : ""}$${Math.abs(n).toLocaleString("en-AU", { maximumFractionDigits: 0 })}`;
